const SCROLLABLE_OVERFLOW = /(auto|scroll)/;

export function findScrollParent(element: HTMLElement | null): HTMLElement | null {
    let current = element?.parentElement ?? null;

    while (current) {
        if (SCROLLABLE_OVERFLOW.test(getComputedStyle(current).overflowY)) {
            return current;
        }
        current = current.parentElement;
    }

    return null;
}
